import { AqiCategory, OutdoorCityTabItem, WeatherIcon } from './types';

export const FORECAST_SLOT_COUNT = 3;

export const MORNING_END_HOUR = 12;

export const AFTERNOON_END_HOUR = 18;

export const DEFAULT_OUTDOOR_SOURCES = ['Weather', 'AirNow AQI', 'NOAA HMS Smoke'] as const;

export const AQI_CATEGORY_UPPER_BOUNDS: ReadonlyArray<{ max: number; category: AqiCategory }> = [
    { max: 25, category: 'ideal' },
    { max: 50, category: 'good' },
    { max: 100, category: 'moderate' },
    { max: 150, category: 'sensitive' },
    { max: 200, category: 'unhealthy' },
    { max: 300, category: 'very-unhealthy' },
];

export const WEATHER_ICON_CLASS: Record<WeatherIcon, string> = {
    sun: 'ri-sun-line',
    'partly-cloudy': 'ri-sun-cloudy-line',
    cloud: 'ri-cloudy-line',
};

export const OUTDOOR_CITY_TABS: OutdoorCityTabItem[] = [
    { id: 'all', labelKey: 'all_cities' },
    // { id: 'watchlist', labelKey: 'watchlist' },
    // { id: 'region', labelKey: 'by_region' },
];
